import { Component, OnInit, ElementRef, Output, ViewChild, Input, EventEmitter, OnDestroy } from '@angular/core';
import { TournamentsService } from '../tournaments/services/tournaments.service';
import { CoreService, CustomerUser } from '../services/core.service';
import { Observable, Subscription, timer } from 'rxjs';
import { Router } from '@angular/router';
import { translationHelper } from '~/helpers/translation.helper';
import { uiHelper } from '~/helpers/ui.helper';
declare let $;
declare let SetLanguage: any;

@Component({
    selector: 'comp_cashoutdetail',
    templateUrl: './cashoutdetail.html',
})
export class CashoutDetail implements OnInit, OnDestroy {
    CashOutValueSend;
    WithdrawValueSend;
    CashoutButtonClick = 0;
    CashOutTimerCounter = 10;
    PayOutTimerCounter = 10;
    PayoutTimerMessageActive = 0;
    TimerMessageActive = 0;
    setIntervalClear;
    setIntervalClearPayout;
    openbetsCashoutValueDetail = 0;
    loadingIsActive = false;
    constructor(
        public tournamentsService: TournamentsService,
        private router: Router,
        private coreService: CoreService,
        private _translate: translationHelper,
        public _uiHelper: uiHelper,
    ) {}
    subClientCO: Subscription;
    private timercashoutvalue;
    private timercashoutdetailList;
    init: boolean;
    ngOnInit() {
        if (this.init) return;
        this.init = true;
        //this.tournamentsService.SlipCashOutSlipNumber = 36029;

        if (this.tournamentsService.SlipCashOutSlipNumber != 0) {
            this.tournamentsService.getCashoutDetail_Terminal();
            this.tournamentsService.getCashOutValue_Terminal();
            this.RefreshCashoutValue();
            setTimeout(() => {
                this.setPercent(100, this.getCashoutValue(this.tournamentsService.cashOutValueList_Terminal[0], true));
            }, 1000);
        }
        SetLanguage('', '');
    }
    percent = 100;                    // slider ve butonlar
    payoutNow = 0;                   // şimdi ödenecek tutar
    remainingStake = 0; // kalan bahis
    setPercent(p: number, cashOutValue: number): void {
      this.percent = p;
      this.payoutNow = this.round2(cashOutValue * (p / 100));          // tıklanan yüzde kadar ödenecek
      this.remainingStake = this.round2(cashOutValue -  this.payoutNow); // kalan bahis
    }
    
    private round2(n: number): number {
      return Math.round(n * 100) / 100;
    }
    calculatePartialCashout(cashOutValue: number): number {
      return +(cashOutValue * (this.percent / 100)).toFixed(2);
    }
    RefreshCashoutValue() {
        this.tournamentsService.isCashOut = null;
        this.tournamentsService.isPayOut = null;
        if (this.tournamentsService.cashoutdetail_subClientCO != undefined)
            this.tournamentsService.cashoutdetail_subClientCO.unsubscribe();
        this.tournamentsService.timer_cashoutvalue = timer(12000, 12000);
        this.tournamentsService.cashoutdetail_subClientCO = this.tournamentsService.timer_cashoutvalue.subscribe(t =>
            this.tournamentsService.getCashOutValueRefresh_Terminal(),
        );
    }
    setCashOutScreen() {
        this.tournamentsService.isCashOut = null;
        this.tournamentsService.isPayOut = null;
        if (this.tournamentsService.cashoutdetail_subClientCO != undefined)
            this.tournamentsService.cashoutdetail_subClientCO.unsubscribe();
        this.tournamentsService.timer_cashoutvalue = timer(0, 12000);
        this.tournamentsService.cashoutdetail_subClientCO = this.tournamentsService.timer_cashoutvalue.subscribe(t =>
            this.tournamentsService.getCashOutValueRefresh_Terminal(),

        );

    }

    CashOutPay(CashOutValue,PayoutNow='') {
        // console.log("CashOutPay",CashOutValue);
        this.CashOutTimerCounter = 10;
        this.TimerMessageActive = 1;
        //this.CashOutValueSend = CashOutValue;
        this.tournamentsService.cashOutButtonClick = 1;
        this.tournamentsService.CashOutPayAcceptValue = CashOutValue;
        this.tournamentsService.PayoutNow = this.percent === 100 ? '' : (this.percent/100).toString();

        this.setIntervalClear = setInterval(() => this.CashOutTimerCounter_Func(), 1000);
        setTimeout(() => this.CashoutValueOk_Func(), 10000);
        this.setCashOutScreen();
        //$('#cashoutdetail_modalcashout').modal('show');
    }
    CashOutTimerCounter_Func() {
        //console.log("CashOutTimerCounter_Func");
        //console.log("geldiasddddddddddddddddddddddddddddddddddddddddddddddddddddddddddd");
        this.CashOutTimerCounter = this.CashOutTimerCounter - 1;
        if (this.CashOutTimerCounter == 0) {
            //console.log("geldi");
            this.TimerMessageActive = 0;
            clearInterval(this.setIntervalClear);
            this.CashoutValueOk_Func();
        }
    }
    CashOutPayOpenBets(CashoutValueOb) {
        //console.log("CashOutPayOpenBets");
        this.openbetsCashoutValueDetail = CashoutValueOb;
        $('#openBetsCashoutModalDetail')
            .modal({
                detachable: false,
            })
            .modal('show');
    }
    ObCashoutModalExitDetail() {
        $('#openBetsCashoutModalDetail').modal('hide');
    }
    ObCashoutValueOkDetail(cashOutValue) {
        $('#openBetsCashoutModalDetail').modal('hide');
        this.coreService.OpenCashoutWaitingModal();
        this.tournamentsService.getsendCashOutCOpenBets_Terminal(
            cashOutValue,
            this.tournamentsService.SlipCashOutSlipNumber,
            $('input[name="__RequestVerificationToken"]').val(),this.percent === 100 ? '' : (this.percent/100).toString()
        );
    }
    PayOutTimerCounter_Func() {
        //console.log("PayOutTimerCounter_Func");
        //console.log("geldiasddddddddddddddddddddddddddddddddddddddddddddddddddddddddddd");
        this.PayOutTimerCounter = this.PayOutTimerCounter - 1;
        if (this.PayOutTimerCounter == 0) {
            //console.log("geldi");
            this.PayoutTimerMessageActive = 0;
            clearInterval(this.setIntervalClear);
            this.PayoutValueOk_Func();
        }
    }
    //WithdrawPay(WithdrawValue)
    //{

    //    this.WithdrawValueSend = WithdrawValue;

    //    $('#cashoutdetail_modalwithdraw').modal('show');
    //}
    WithdrawPay(WithdrawValue) {
        console.log('WithdrawValue', WithdrawValue);
        if (this.coreService.CustomerCardIsActive == 0 && WithdrawValue > 2000) {
            this.tournamentsService.payOutButtonClick = 0;
            $('#Payout_Limit_Modal').modal('show');
        } else {
            this.PayOutTimerCounter = 10;
            this.PayoutTimerMessageActive = 1;
            //this.CashOutValueSend = CashOutValue;
            this.tournamentsService.payOutButtonClick = 1;
            this.tournamentsService.PayoutPayAcceptValue = WithdrawValue;
            this.setIntervalClearPayout = setInterval(() => this.PayOutTimerCounter_Func(), 1000);
            setTimeout(() => this.PayoutValueOk_Func(), 1000);
        }
    }
    CashoutValueOk() {
        //console.log("CashoutValueOk");
        clearInterval(this.timercashoutdetailList);
        this.timercashoutdetailList = null;
        clearInterval(this.tournamentsService.timer_cashoutvalue);
        this.tournamentsService.timer_cashoutvalue = null;

        //this.tournamentsService.getsendCashOut_Terminal(this.CashOutValueSend, this.tournamentsService.SlipCashOutSlipNumber, $('input[name="__RequestVerificationToken"]').val());
        //$('#cashoutdetail_modalcashout').modal('hide');
        //setTimeout(function () { $('#cashoutdetail_creditvoucher').modal('show'); }, 1000);
    }
    CashoutValueOk_Func() {
        //console.log("CashoutValueOk_Func");
        this.tournamentsService.SlipNumberControl = 0;
        this.tournamentsService.SlipCashOutSlipPasswordControl = 0;
        this.tournamentsService.cashOutButtonClick = 0;
        clearInterval(this.timercashoutdetailList);
        this.timercashoutdetailList = null;
        clearInterval(this.tournamentsService.timer_cashoutvalue);
        this.tournamentsService.timer_cashoutvalue = null;
    }
    PayoutValueOk_Func() {
        //console.log("PayoutValueOk_Func");
        this.tournamentsService.SlipNumberControl = 0;
        this.tournamentsService.SlipCashOutSlipPasswordControl = 0;
        this.tournamentsService.payOutButtonClick = 0;
        clearInterval(this.setIntervalClearPayout);
        this.setIntervalClearPayout = null;
        clearInterval(this.tournamentsService.timer_cashoutvalue);
        this.tournamentsService.timer_cashoutvalue = null;
    }
    CashoutModalExit() {
        $('#cashoutdetail_modalcashout').modal('hide');
    }
    WithdrawModalExit() {
        $('#cashoutdetail_modalwithdraw').modal('hide');
    }
    WithdrawValueOk() {
        clearInterval(this.timercashoutdetailList);
        this.timercashoutdetailList = null;
        clearInterval(this.tournamentsService.timer_cashoutvalue);
        this.tournamentsService.timer_cashoutvalue = null;
        this.tournamentsService.getsendPayout_Terminal(
            this.WithdrawValueSend,
            this.tournamentsService.SlipCashOutSlipNumber,
            $('input[name="__RequestVerificationToken"]').val(),
        );

        $('#cashoutdetail_modalcashout').modal('hide');
        // setTimeout(function() {
        //     $('#cashoutdetail_creditvoucher').modal('show');
        // }, 1000);
    }
    CashoutDetail_Print() {
        SetLanguage('', '');
        this.tournamentsService.getPrintSlip_Cashout(this.tournamentsService.SlipCashOutSlipNumber);
    }
    RestoreBettingSlip() {
        //$('#cashoutdetail_creditvoucher').modal('show');

        this.tournamentsService.RestoreSlip_Terminal(
            this.tournamentsService.SlipCashOutSlipNumber,
            $('input[name="__RequestVerificationToken"]').val(),
        );
        // this.changeTaxAmount();
    }
    ExitCreditVoucherModal() {
        $('#cashoutdetail_creditvoucher').modal('hide');
    }
    public changeTaxAmount() {
        this.tournamentsService.amount = (
            (Number(this.tournamentsService.CalculatorValue) * 100) /
            (100 + this.tournamentsService.tax)
        ).toFixed(6);
        this.tournamentsService.changeSlipAmount(
            this.tournamentsService.amount,
            this.tournamentsService.BettingSlip_Menu_SlipType,
        );
    }
    getcashOutSendVisibilty() {
        if (this._uiHelper.terminalConfig.IsJacktimeActive === true) {
            if (this.tournamentsService.cashOutValueList_Terminal.filter(x => x.CashOutValueJacktime == 0).length > 0) {
                return 'disabled';
            }
            return '';
        } else {
            if (
                this.tournamentsService.cashOutValueList_Terminal.find(x => x.IsActive == 'false') != null ||
                this.tournamentsService.cashOutValueList_Terminal.find(x => x.CashOutValue == 0) != null
            ) {
                return 'disabled';
            } else {
                //Check match id's in live socket enable or not
                let flagMatchClose = false;
                if (this.tournamentsService.cashOutValueList_Terminal != undefined) {
                    this.tournamentsService.cashOutValueList_Terminal.map(slip => {
                        if (this._uiHelper.liveFilteredData != undefined) {
                            const match = this._uiHelper.liveFilteredData.find(match => match.MatchId == slip.MatchId);
                            if (match != undefined) {
                                //console.warn("Maç bulundu. " + match.HomeTeam);
                                if (match.ExtraOddCount == 0) {
                                    //console.log('CASHOUT KAPAT ' + match.HomeTeam);
                                    flagMatchClose = true;
                                    return;
                                }
                            }
                        }
                    });
                }
                if (flagMatchClose) {
                    return 'disabled';
                }

                return '';
            }
        }
    }
    // getcashOutMessage() {
    //     if (this.tournamentsService.cashOutValueList_Terminal.find(x => x.IsActive == 'false') != null)
    //         return this._translate.getT('CashOut_Is_Not_Active');
    //     else return this._translate.getT('CashOut_Is_Active');
    // }
    SubmitNewBet() {
        $('#cashoutdetail_creditvoucher').modal('hide');
        this.router.navigate(['/LiveBets']);
        setTimeout(function() {
            $('#cashoutdetail_creditvoucher').modal('hide');
        }, 1000);
    }
    WithdrawPayAcceptTry(e) {
        //this.tournamentsService.confirmTicketCounterPayout = 3;
        //this.tournamentsService.confirmMessageActivePayout = 1;
        //this.tournamentsService.confirmTicketSetIntervalClearPayout = setInterval(() => this.tournamentsService.ConfirmTicketCounterPayout_Func(), 1000);
    }
    ExitCreditVoucherModalCOb() {
        $('#cashoutdetail_creditvoucheropenbetsCd').modal('hide');
    }
    SubmitNewBetCOb() {
        $('#cashoutdetail_creditvoucheropenbetsCd').modal('hide');
        this.tournamentsService.router.navigate(['/LiveBets']);
    }

    ngOnDestroy() {
        this.tournamentsService.TicketKeyboardModalIsActive = false;
        if (this.tournamentsService.cashoutdetail_subClientCO != undefined) {
            this.tournamentsService.cashoutdetail_subClientCO.unsubscribe();
        }

        clearInterval(this.timercashoutdetailList);
        this.timercashoutdetailList = null;
        clearInterval(this.tournamentsService.timer_cashoutvalue);
        this.tournamentsService.timer_cashoutvalue = null;

        clearInterval(this.setIntervalClear);
        this.setIntervalClear = null;

        clearInterval(this.setIntervalClearPayout);
        this.setIntervalClearPayout = null;

        this.tournamentsService.clear_SlipDetail_Cashout_Counter();
    }

    TicketChecker_Payout(value) {
        this.tournamentsService.TicketKeyboardModalIsActive = false;
        this.tournamentsService.getsendPayout_Terminal(
            value,
            this.tournamentsService.SlipCashOutSlipNumber,
            $('input[name="__RequestVerificationToken"]').val(),
        );
    }
    TicketChecker_Cashout(value) {
        this.tournamentsService.TicketKeyboardModalIsActive = false;
        this.tournamentsService.getsendCashOut_Terminal(
            value,
            this.tournamentsService.SlipCashOutSlipNumber,
            $('input[name="__RequestVerificationToken"]').val(), this.percent === 100 ? '' : (this.percent/100).toString()
        )
        this.setCashOutScreen();
    }

    DuplicateBettingSlip() {
        this.loadingIsActive = true;
        this.tournamentsService.getSlipDuplicate(this.tournamentsService.SlipCashOutSlipNumber);
        // this._uiHelper.SetSlipDuplicateModal(true);
        //$('#Slip_Duplicate_Modal').modal('show');
        setTimeout(() => (this.loadingIsActive = false), 5000);
    }
    getCashoutValue(slip: any, isNumber = false) {
        try {
            if (slip != undefined)
                if (this._uiHelper.terminalConfig.IsJacktimeActive === true) {
                    let cashoutSlip = this.tournamentsService.cashOutValueList_Terminal.filter(
                        i => i.SlipId == slip.SlipId,
                    );
                    return isNumber
                        ? slip.CashOutValueJacktime === 0
                            ? slip.CashOutValueJacktime
                            : slip.CashOutValueJacktime - 0.01
                        : (slip.CashOutValueJacktime === 0
                              ? slip.CashOutValueJacktime
                              : slip.CashOutValueJacktime - 0.01
                          ).toFixed(2);
                } else {
                    return isNumber ? slip.CashOutValue : slip.CashOutValue.toFixed(2);
                }
        } catch (e) {
            console.log(e);
        }
    }
}
